export const API_URL = {
  development: "https://myprotour.com/api/hotel/",
  production: "https://myprotour.com/api/hotel/",
};

export const API_URL2 = {
  development: "https://myprotour.com/api/hotel/",
  production: "https://myprotour.com/api/hotel/",
};

export const API_URL3 = {
  development: "https://myprotour.com/api/",
  production: "https://myprotour.com/api/",
};

export const UPLOAD_URL = {
  development: "https://myprotour.com/hotel/media/others/",
  production: "https://myprotour.com/hotel/media/others/",
};

export const SERVE_URL = {
  development: "https://myprotour.com/hotel",
  production: "https://myprotour.com/hotel",
};
//"http://localhost:4200"
export const errorsStaff = {
  firstname: "Firstname is not valid",
  lastname: "Lastname is not valid",
  email: "Email is not valid",
  password: "Password should be at least 8 characters long",
};

//"prisma migrate dev -n 0_0 && prisma generate && nodemon server.js"